import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSEO } from "@/lib/use-seo";

const CheckoutReturn = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  useSEO({
    title: "Thank You — AI for HR Mastermind",
    description: "Your Premium Membership purchase is complete.",
    path: "/checkout/return",
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-background pt-28 pb-16 flex items-center">
      <div className="section-inner max-w-xl text-center">
        {sessionId ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-primary mx-auto mb-6" />
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              Welcome to the Premium Membership!
            </h1>
            <p className="text-lg text-foreground/80 mb-6 leading-relaxed">
              Your payment was successful. Thank you for joining us!
            </p>
            <p className="text-base text-foreground/80 mb-8 leading-relaxed">
              Look out for a welcome email from{" "}
              <span className="font-semibold text-foreground whitespace-nowrap">
                ai-for-hr-mastermind@app.disco.co
              </span>{" "}
              within the next 5 minutes with your access details and next steps.
            </p>
            <Button asChild size="lg">
              <Link to="/">Back to home</Link>
            </Button>
          </>
        ) : (
          <>
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              No checkout session found
            </h1>
            <p className="text-base text-foreground/80 mb-8 leading-relaxed">
              This page needs a payment session, and there isn&apos;t one in the
              link you used. If you already paid, your receipt email is
              confirmation &mdash; forward it to{" "}
              <span className="font-semibold text-foreground whitespace-nowrap">
                hello@aiforhrmastermind.com
              </span>{" "}
              and we&apos;ll confirm your access. If you haven&apos;t paid yet,
              start from the membership page.
            </p>
            <Button asChild size="lg">
              <Link to="/membership">View membership options</Link>
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default CheckoutReturn;
